import React from "react";
import { LegendPayload } from "recharts";

/**
 * SVG icon renderer for line charts
 * Displays a line with a hollow circle in the center
 */
export const lineChartIcon = (entry: LegendPayload, index: number): React.ReactNode => {
  return (
    <svg width="18" height="8" viewBox="0 0 18 8" style={{ marginRight: "4px" }}>
      <line x1="0" y1="4" x2="6" y2="4" stroke={entry.color} strokeWidth="2" />
      <line x1="12" y1="4" x2="18" y2="4" stroke={entry.color} strokeWidth="2" />
      <circle cx="9" cy="4" r="3" fill="none" stroke={entry.color} strokeWidth="2" />
    </svg>
  );
};
